// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Проблеми» (Issues, ключ `iss`, група `management`). */
export const issuesManifest: IModuleManifest = {
  key: 'iss',
  group: 'management',
  slug: 'issues',
  prefix: 'ISS',
  name: { en: 'Issues', uk: 'Проблеми' },
  entities: [
    { key: 'iss', slug: 'iss', name: { en: 'Issues', uk: 'Проблеми' }, main: true },
    { key: 'issue_project', slug: 'issue-project', name: { en: 'Issue Projects', uk: 'Проєкти' }, main: false },
    { key: 'issue_resolution', slug: 'issue-resolution', name: { en: 'Issue Resolutions', uk: 'Вирішення' }, main: false },
  ],
  loadState: () => import('./state/issuesSlice').then((m) => m.issuesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
